module.exports = __webpack_public_path__ + "img/img8.3b05594a.png";